import { createContext } from "react";

export const GlobalStatsContext = createContext(null)
export const UserStatsContext = createContext(null)